function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useViewport } from '@cb/react-hooks';
var processBreakpoint = function processBreakpoint(name) {
  return {
    xxxl: name === '3xl',
    xxl: name === '2xl',
    xl: name === 'xl',
    oversize: name === 'lg',
    desktop: name === 'md',
    tablet: name === 'sm',
    mobile: name === 'xs',
    current: name
  };
};
export default (function (Component) {
  return function (props) {
    var breakpoint = processBreakpoint(useViewport());
    return /*#__PURE__*/React.createElement(Component, _extends({
      breakpoint: breakpoint
    }, props));
  };
});